import { createAction } from '~/Helpers/Action.helpers';
import { STATIC_ACTIONS } from '~/Constants/Actions.constants';

export const requestClearBookableCustomers = () =>
  createAction({
    type: STATIC_ACTIONS.CLEAR_BOOKING_SEARCH,
    name: STATIC_ACTIONS.CLEAR_BOOKING_SEARCH,
  });
